export default __webpack_public_path__ + "static/media/cafgu-success-confetti.40aba134.png";